import React from 'react'
import styled from '@emotion/styled'
import { COLORS } from '@borrowell/bw-styles'

import { useGatsbyContentfulRefreshStatus } from '../hooks/useGatsbyContentfulRefreshStatus'

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 16px;
  background: ${COLORS.PRIMARY.DEFAULT};
  color: ${COLORS.WHITE};
  font-family: system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
`

const Spinner = styled.span`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: ${COLORS.WHITE};
  border-radius: 50%;
  animation: contentful-preview-refresh-spin 0.7s linear infinite;

  @keyframes contentful-preview-refresh-spin {
    to {
      transform: rotate(360deg);
    }
  }
`

/**
 * Preview-iframe-only indicator shown while Contentful → Gatsby refresh is in flight
 * (POST + develop re-source). Hosted preview can take a while; this keeps editors informed.
 */
export const ContentfulPreviewRefreshBanner = (): React.ReactElement | null => {
  const isRefreshing = useGatsbyContentfulRefreshStatus()

  if (!isRefreshing) return null

  return (
    <Banner role="status" aria-live="polite">
      <Spinner aria-hidden />
      Refreshing preview…
    </Banner>
  )
}
